module.exports = __webpack_public_path__ + "img/tabIcHomeOn.e5f64ff2.svg";